import React from 'react'

const FeedbackMessage = ({value}) => {
  if (value) return <p className='text-red-600 bg-red-50 p-2 border border-red-600 rounded-md break-words overflow-x-auto '>{value}</p>
  return null
}

export default FeedbackMessage
